export default __webpack_public_path__ + "static/media/ads-mobile-2.d79a49c6.gif";